import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md, fontH2 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content.interactive {
    width: min(620px, calc(100vw - ${spacing(12)}));
  }

  &.GoogleWorkspaceIntegrationManageModal .BaseModal-Body {
    display: grid;
    gap: ${spacing(6)};
    padding: ${spacing(8)};
  }

  .GoogleWorkspaceIntegrationManageModal-header,
  .GoogleWorkspaceIntegrationManageModal-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(3)};
    flex-wrap: wrap;
  }

  h1 {
    ${fontH2};
  }

  p,
  dt,
  dd {
    ${font_md};
  }

  dl {
    display: grid;
    gap: ${spacing(3)};
  }

  dl > div {
    display: grid;
    grid-template-columns: minmax(120px, 1fr) minmax(0, 2fr);
    gap: ${spacing(3)};
  }

  dt {
    color: ${text_colorTextSecondary};
  }

  .GoogleWorkspaceIntegrationManageModal-actions {
    justify-content: flex-end;
  }
`
